import React from 'react'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import { PMPBodySectionItems } from './styledComponent'
import { getCasedHeadingTextBasedOnStyleOverrides } from 'src/mentor/components/PrescriptionMakingPage/printComponents/printComponents/prescriptionPrintableItems/util'
import { getSectionListFormatConfig, renderSectionLabelList } from './sectionListFormat'

export default function PrintablePrescriptionAdvice({
  prescriptionAdviceRef,
  debug,
  selectedAdvice,
  debugHighlightStates,
  styleOverrides,
  listItemSeparator,
}) {
  const listCfg = getSectionListFormatConfig(styleOverrides, listItemSeparator)
  return (
    <PMPBodySectionItems
      borderLeft={styleOverrides?.borderLeft}
      paddingLeft={styleOverrides?.paddingLeft}
      ref={prescriptionAdviceRef}
      debug={debug}
      debugColor={PRESCRIPTION_COLORS_MAP.advice.color}
      debugHighlight={debugHighlightStates?.prescriptionAdvice}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
          fontWeight: 600,
        }}
      >
        <strong>
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: 'Advice',
            styleOverrides,
          })}
        </strong>
      </span>
      <div
        style={{
          fontSize: styleOverrides?.fontSizePixels
            ? `${styleOverrides?.fontSizePixels}px`
            : 'inherit',
          color: styleOverrides?.color || 'inherit',
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          maxWidth: '100%',
        }}
      >
        {renderSectionLabelList(selectedAdvice, listCfg)}
      </div>
    </PMPBodySectionItems>
  )
}
